import {Inject, Injectable, DOCUMENT} from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class DashboardService {
    constructor(@Inject(DOCUMENT) private document: Document) {
    }

    setFocusMode(isFocusMode: boolean = true): void {
        this.document.body.classList.toggle('focus', isFocusMode);
    }

    openSidenav(): void {
        (document.querySelector('cm-sidenav') as any).openSidenav();
    }

    closeSidenav(): void {
        (document.querySelector('cm-sidenav') as any).closeSidenav();
    }

    public setContainerWidth(width: 'DEFAULT' | 'FULL' | 'FLUID'): void {
        const containerElement = document.getElementById('container');
        containerElement.classList.remove('container', 'container-fluid', 'container-full');

        if (width === 'DEFAULT') {
            containerElement.classList.add('container');
            return;
        }

        if (width === 'FULL') {
            containerElement.classList.add('container-full');
            return;
        }

        if (width === 'FLUID') {
            containerElement.classList.add('container-fluid');
            return;
        }
    }
}
